(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-product-video-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-product-video-block')) {
    customElements.define('tt-product-video-block', class extends HTMLElement {
      static nextId = 0;
      static pendingForms = new WeakMap();

      connectedCallback() {
        this.listeners?.abort();
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.dialog = this.querySelector('dialog');
        this.video = this.querySelector('video');
        this.opener = this.querySelector('[data-video-open]');
        this.addButton = this.querySelector('[data-video-add]');
        this.cartError = this.querySelector('[data-video-error]');
        this.cartStatus = this.querySelector('[data-video-status]');
        const closeButton = this.querySelector('[data-video-close]');
        if (!this.dialog || !this.video || !this.opener || !closeButton) return;
        this.dialog.id = `TTProductVideoBlock-${++this.constructor.nextId}`;
        this.opener.setAttribute('aria-controls', this.dialog.id);
        this.setCartBusy(Boolean(this.cartRequest));

        this.closest('.shopify-section')?.addEventListener('shopify:product:select', (event) => {
          const sourceCard = event.target.closest?.('product-card');
          if ((sourceCard && !sourceCard.contains(this)) || !event.promise) return;
          const selection = {};
          this.pendingSelection = selection;
          this.selectionFailed = false;
          this.setCartBusy(Boolean(this.cartRequest));
          // Let Horizon finish updating the variant, quantity rules, and native button first.
          Promise.resolve(event.promise).then(
            () => this.finishSelection(selection, false),
            () => this.finishSelection(selection, true)
          );
        }, { ...options, capture: true });

        this.opener.addEventListener('click', () => {
          if (this.dialog.open) return;
          if (!this.cartRequest) this.showCartError('');
          this.dialog.showModal();
          const playback = this.video.play();
          playback?.catch(() => {});
        }, options);

        closeButton.addEventListener('click', () => this.closeVideo(), options);
        this.addButton?.addEventListener('click', () => this.addToCart(), options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeVideo();
        }, options);

        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            this.closeVideo();
          }
        }, options);

        this.dialog.addEventListener('close', () => {
          this.stopVideo();
          if (this.isConnected && !document.querySelector('dialog[open]')) {
            this.opener.focus({ preventScroll: true });
          }
        }, options);
      }

      findProductForm() {
        const section = this.closest('.shopify-section');
        if (!section) return null;
        return Array.from(section.querySelectorAll('product-form-component')).find(
          (component) => component.dataset.productId === this.dataset.productId
        ) || null;
      }

      setCartBusy(busy) {
        if (!this.addButton) return;
        this.addButton.disabled = busy || Boolean(this.pendingSelection);
        this.addButton.setAttribute('aria-busy', String(this.addButton.disabled));
        this.addButton.textContent = busy ? this.dataset.addingLabel : this.dataset.addLabel;
      }

      finishSelection(selection, failed) {
        window.setTimeout(() => {
          if (this.pendingSelection !== selection) return;
          this.pendingSelection = null;
          this.selectionFailed = failed;
          this.setCartBusy(Boolean(this.cartRequest));
        }, 0);
      }

      showCartError(message) {
        if (!this.cartError) return;
        this.cartError.textContent = message;
        this.cartError.hidden = !message;
      }

      addToCart() {
        if (this.cartRequest || this.pendingSelection) return;
        this.showCartError('');
        this.cartStatus.textContent = '';
        const component = this.findProductForm();
        const form = component?.querySelector('form[data-type="add-to-cart-form"]');
        const submitButton = component?.querySelector('[ref="addToCartButton"]');

        if (!form || !submitButton || typeof component.handleSubmit !== 'function') {
          this.showCartError(this.dataset.unavailableLabel);
          return;
        }
        if (this.constructor.pendingForms.has(component)) {
          this.showCartError(this.dataset.addingLabel);
          return;
        }
        const variantInput = form.elements.namedItem('id');
        const quantityCheck = component.refs?.quantitySelector?.canAddToCart?.();
        if (this.selectionFailed || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true' ||
            !variantInput?.value || variantInput.disabled || !form.checkValidity() ||
            quantityCheck?.canAdd === false) {
          this.showCartError(this.dataset.unavailableLabel);
          return;
        }

        const request = { component, controller: new AbortController(), received: false, error: '' };
        this.cartRequest = request;
        this.constructor.pendingForms.set(component, request);
        this.setCartBusy(true);
        const listenerOptions = { capture: true, signal: request.controller.signal };

        component.addEventListener('shopify:cart:error', (event) => {
          if (event.target !== component) return;
          request.error = event.detail?.description || event.error || this.dataset.errorLabel;
          this.showCartError(request.error);
        }, listenerOptions);

        component.addEventListener('shopify:cart:lines-update', (event) => {
          if (event.target !== component || event.action !== 'add' || request.received || !event.promise) return;
          request.received = true;

          event.promise.then((result) => {
            if (result?.detail?.didError || result?.userErrors?.length || request.error) {
              this.finishCartRequest(request, request.error || result?.userErrors?.[0]?.message || this.dataset.errorLabel);
              return;
            }
            this.finishCartRequest(request);
          }).catch(() => this.finishCartRequest(request, request.error || this.dataset.errorLabel));

          if (this.isConnected) {
            const forwarded = new event.constructor({
              action: event.action,
              context: 'dialog',
              lines: event.lines,
              promise: event.promise,
              detail: event.detail,
            });
            event.stopPropagation();
            this.dialog.dispatchEvent(forwarded);
          }
        }, listenerOptions);

        request.timer = window.setTimeout(() => {
          if (this.cartRequest !== request) return;
          if (!request.received) {
            this.finishCartRequest(request, this.dataset.errorLabel);
            return;
          }
          this.showCartError(this.dataset.errorLabel);
        }, 30000);

        try {
          form.requestSubmit(submitButton);
        } catch {
          this.finishCartRequest(request, this.dataset.errorLabel);
        }
      }

      finishCartRequest(request, error = '') {
        if (this.cartRequest !== request) return;
        window.clearTimeout(request.timer);
        request.controller.abort();
        this.constructor.pendingForms.delete(request.component);
        this.cartRequest = null;
        this.setCartBusy(false);
        if (!this.isConnected) return;
        if (error) {
          this.showCartError(error);
          return;
        }
        this.closeVideo();
        this.cartStatus.textContent = this.dataset.addedLabel;
      }

      stopVideo() {
        if (!this.video) return;
        this.video.pause();
        if (this.video.readyState > 0) this.video.currentTime = 0;
      }

      closeVideo() {
        this.stopVideo();
        if (this.dialog?.open) this.dialog.close();
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.closeVideo();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
